'use client';
import { Divider } from '@mantine/core';

import { Button } from '@scaleup/frontend/ui';
import { IconArrowRight, IconCheck } from '@tabler/icons-react';
import { Sparkle } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';
import { useSupplierIntakeContext } from './context';

export const Init = () => {
  const INTAKE_STEPS = [
    {
      name: 'Company Details',
      description: 'Share key information about your business',
    },
    {
      name: 'Basic Information',
      description: 'Tell us about your leadership and team',
    },
    {
      name: 'Certifications and Compliance',
      description: 'Share details about your industry and demographic certifications',
    },
    {
      name: 'Market & Industry',
      description: 'Define your industry focus and target markets',
    },
    {
      name: 'Customer Information',
      description: 'Highlight your experience and key clients',
    },
    {
      name: 'NAICS codes',
      description: 'Classify your business for enterprise sourcing',
    },
  ];
  const { setCurrentStep } = useSupplierIntakeContext();
  const [nextStep, setNextStep] = useState(false);

  const IntakeSteps = () => {
    return (
      <div className="flex flex-col gap-4">
        {INTAKE_STEPS.map(({ name, description }) => (
          <div className="flex gap-2 items-center">
            <div className="rounded-full flex items-center justify-center bg-white w-[1.5rem] h-[1.5rem]">
              <IconCheck size={18} stroke={3} color="#1d2939" />
            </div>
            <p>
              <span className="text-text-primary font-bold">{name} - </span>{' '}
              <span className="text-text-secondary">{description}</span>
            </p>
          </div>
        ))}
      </div>
    );
  };

  const render = () => {
    if (nextStep) {
      return (
        <div className="flex flex-col gap-6">
          <p className="text-text-primary text-xl font-bold">
            Supplier Intake - What to Expect:
          </p>

          <IntakeSteps />

          <div>
            <Divider color="#83cadd" />
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <Sparkle size={16} color="#e67a0f" />
              <p className="text-text-primary">
                <strong>Estimated Time to Complete:</strong> 20-30 min
              </p>
            </div>

            <div className="flex gap-2 items-center">
              <Sparkle size={16} color="#e67a0f" />
              <p className="text-text-primary">
                <strong>Progress is Saved Automatically</strong>
              </p>
            </div>
          </div>

          <div className="w-[140px] pt-8">
            <Button
              variant="secondary"
              onClick={() => setCurrentStep('details')}
              text="Begin"
              suffixIcon={<IconArrowRight />}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="flex flex-col gap-6">
        <p className="text-text-primary text-3xl font-bold">
          Welcome to Scaleup!
        </p>

        <p className="text-text-primary text-lg">
          Now that you're officially a Scaleup supplier, it's time for
          onboarding!
        </p>

        <div className="flex gap-4 items-start">
          <div className="pt-1">
            <Sparkle size={16} color="#e67a0f" />
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-text-primary font-bold">
              Step 1: Supplier Intake
            </p>
            <p className="text-text-primary">
              This form helps us to build a robust company profile for you,
              ensuring you receive the right enterprise matches and
              opportunities.
            </p>
          </div>
        </div>

        <div className="w-[140px] pt-8">
          <Button
            variant="secondary"
            onClick={() => setNextStep(true)}
            text="Continue"
            suffixIcon={<IconArrowRight />}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="rounded-[2rem] bg-primary-100 flex justify-between gap-8 p-16">
      <div className="flex items-center p-8 max-w-[40rem]">{render()}</div>
      <div className="hidden lg:flex items-center">
        <Image src="/supplier-intake.png" alt="" width={460} height={552} />
      </div>
    </div>
  );
};
